import apiClient from './base.api'
const BASE_ENDPOINT = window.config.AGENTS_BASE_ENDPOINT

export const fetchAgentsAsync = async() => {
  return await apiClient.get(`${BASE_ENDPOINT}agents/`)
}

export const updateAgentStatusAsync = async(agentId, status) => {
  return await apiClient.patch(`${BASE_ENDPOINT}agents/${agentId}/`, { validated: status })
}

export const startAgentAsync = async(agentId) => {
  return await apiClient.post(`${BASE_ENDPOINT}agents/${agentId}/start/`)
}

export const stopAgentAsync = async(agentId) => {
  return await apiClient.post(`${BASE_ENDPOINT}agents/${agentId}/stop/`)
}

export const fetchAgentQrCodeAsync = async(agentId) => {
  return await apiClient.get(`${BASE_ENDPOINT}agents/${agentId}/get_qr/`, { responseType: 'blob' })
}

export const getAuthCodeAsync = async(agentId, phoneNumber) => {
  return await apiClient.post(`${BASE_ENDPOINT}agents/${agentId}/get_auth_code/`, {
    phoneNumber: phoneNumber
  })
}

export const fetchAgentDetailAsync = async(agentId) => {
  return await apiClient.get(`${BASE_ENDPOINT}agents/${agentId}/`)
}

export const fetchTopicsAsync = async() => {
  return await apiClient.get(`${BASE_ENDPOINT}topics/`)
}

export const fetchLanguagesAsync = async() => {
  return await apiClient.get(`${BASE_ENDPOINT}languages/`)
}

export const updateAgentAsync = async(agentId, payload) => {
  return await apiClient.put(`${BASE_ENDPOINT}agents/${agentId}/`, payload)
}

export const createAgentAsync = async(payload) => {
  return await apiClient.post(`${BASE_ENDPOINT}agents/`, payload)
}

export const fetchMaxPhoneNumberChangesAsync = async() => {
  return await apiClient.get(`${BASE_ENDPOINT}agents/get_max_changes/`)
}

export const fetchAgentGroupsAsync = async(agentId, active = true) => {
  return await apiClient.get(`${BASE_ENDPOINT}groups/`, {
    params: { agentId, active }
  })
}

export const uploadAgentChatsAsync = async(agentId) => {
  return await apiClient.post(`${BASE_ENDPOINT}agents/${agentId}/import_phonebook/`)
}

export const refreshAgentAsync = async(agentId) => {
  return await apiClient.post(`${BASE_ENDPOINT}agents/${agentId}/refresh/`)
}
